<template>
  <div>
    <div class="mb-3">
      <div class="section-title mb-3">{{ $t("accerssrightforschedule") }}</div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Movie.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("movie", 2) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Movie"
                variant="dropdown-curve"
                class="w-100"
                @shown="onClickMovieList"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    type="search"
                    ref="searchMoviesList"
                    name="searchMoviesList"
                    id="searchMoviesList"
                    :placeholder="$tc('searchMovie')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchMovie()"
                    v-on:keydown="onSearchMovie()"
                    v-on:search="onSearchMovie()"
                    v-model="searchMovie"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in MoviesList"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectHandler('movie', Item)"
                  >{{ Item.movie_name }}</b-dropdown-item
                >
                <b-dropdown-item @click="onSelectAll('movie')">{{
                  $t("all")
                }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <multiselect
            :multiple="false"
            placeholder="Select Cinema"
            :group-select="false"
            select-label="Select"
            v-model="selectedCinema"
            label="cine_name"
            :options="cinemaList"
            deselect-label="Remove"
            track-by="cine_id"
            @select="onSelectCinema($event)"
            @remove="onRemoveCinema($event)"
          ></multiselect>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <multiselect
            :multiple="false"
            placeholder="Select Screen"
            :group-select="false"
            select-label="Select"
            v-model="selectedScreen"
            label="screen_name"
            :options="screenList"
            deselect-label="Remove"
            track-by="screen_id"
            @select="onSelectScreen($event)"
            @remove="onRemoveScreen($event)"
          ></multiselect>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker
                :monday-first="true"
                v-model="selected.FromDate"
                name="access_rights_from_date"
                id="access_rights_from_date"
                :typeable="true"
              ></Datepicker>
              <label :class="selected.FromDate ? 'active' : ''">{{
                $t("fromdate")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker
                :monday-first="true"
                v-model="selected.ToDate"
                name="access_rights_to_date"
                id="access_rights_to_date"
                :typeable="true"
              ></Datepicker>
              <label :class="selected.ToDate ? 'active' : ''">{{
                $t("todate")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-4 d-flex">
          <button
            @click.prevent.stop="onSaveChanges"
            class="btn-blue m-0 mr-2"
            title="Save Changes"
          >
            Save
          </button>
          <button
            @click.prevent.stop="getMovieBasedSchedule(true)"
            class="btn-blue m-0"
          >
            {{ $t("fetch") }}
          </button>
        </div>

        <div
          class="col-lg-3 col-xl-12 align-self-center mb-4 d-flex justify-content-end"
        >
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <div class="table-responsive ars-nowrap-wrapper">
        <table class="table ars-nowrap-table">
          <thead>
            <tr>
              <th>{{ $tc("Sr. No") }}</th>
              <th>{{ $tc("movieName") }}</th>
              <th>{{ $tc("date") }}</th>
              <th style="text-align: center">{{ $tc("showtime") }}</th>
              <th class="ars-users-header" style="padding-left: 0; padding-right: 0;">
                <div class="ars-users-label" style="padding-left: 16px;">
                  {{ $tc("users") }}
                </div>
                <div
                  class="ars-scroll-container ars-header-scroll"
                  ref="headerScroll"
                  @scroll="onHeaderScroll"
                >
                  <div class="ars-users-row">
                    <div
                      v-for="user in Users"
                      :key="'hdr-' + user.user_id"
                      class="ars-user-col"
                    >
                      <label class="ars-checkbox-wrap ars-checkbox-wrap--header">
                        <input
                          type="checkbox"
                          :checked="getHeaderState(user.user_id).checked"
                          :indeterminate.prop="
                            getHeaderState(user.user_id).indeterminate
                          "
                          @change="onBulkToggleUser(user)"
                        />
                        <span>{{ user.username }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            <template v-for="(movie, movieIndex) in Records">
              <tr
                v-for="(show, showIndex) in movie.Shows"
                :key="'show-' + show.ss_id + '-' + showIndex"
                :class="show.is_sch_disable == 'Y' ? 'disableSchProp' : ''"
                class="light_grey_back"
              >
                <td class="hei text-center">{{ show.srno }}</td>
                <td class="hei">
                  {{ show.movie_title }} {{ show.language_name }}
                  {{ show.movie_format }}
                </td>
                <td class="hei">
                  {{
                    (show.ss_actual_start_date || show.ss_start_date) | dateparse
                  }}
                </td>
                <td style="text-align: center" class="hei">
                  {{ show.ss_start_show_time }}
                </td>
                <td class="hei ars-users-cell" style="padding: 0;">
                  <div
                    v-if="show.is_sch_disable != 'Y'"
                    class="ars-scroll-container ars-body-scroll"
                    @scroll="onBodyScroll($event)"
                  >
                    <div class="ars-users-row">
                      <div
                        v-for="user in Users"
                        :key="
                          'row-' +
                            show.ss_id +
                            '-' +
                            user.user_id +
                            '-' +
                            (isUserSelected(show, user) ? '1' : '0')
                        "
                        class="ars-user-col"
                      >
                        <label
                          class="ars-checkbox-wrap"
                          :class="{ 'ars-checked': isUserSelected(show, user) }"
                          @click.prevent.stop="onToggleUserInShow(show, user)"
                        >
                          <input
                            type="checkbox"
                            tabindex="-1"
                            :checked="isUserSelected(show, user)"
                            @click.prevent
                          />
                          <span>{{ user.username }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div v-else class="ars-disabled-text text-center">
                    {{ "Schedule Disabled" }}
                  </div>
                </td>
              </tr>
            </template>
          </tbody>

          <tbody v-if="Records.length == 0">
            <tr>
              <td colspan="5">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import scheduleService from "@/services/scheduleService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import moment from "moment";

export default {
  name: "access-rights-for-schedule",
  components: {
    NoRecords,
  },
  data() {
    return {
      ChangeMovie: false,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      MoviesListCopy: [],
      searchMovie: "",
      Records: [],
      TempData: [],
      selectedUsers: [],
      Users: [],
      MoviesList: [],
      selected: {
        Movie: "All",
        MovieId: "",
        FromDate: "",
        ToDate: "",
      },
      viewingnumbers: null,
      cinemaList: [],
      selectedCinema: "",
      cinema_id: null,
      screenList: [],
      selectedScreen: "",
      pendingChanges: {},
      selectionEpoch: 0,
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
    headerCheckboxStates() {
      const statess = {};
      if (!this.Users || this.Users.length === 0) return statess;
      const activeShows = [];
      this.Records.forEach((movie) => {
        if (movie.Shows) {
          movie.Shows.forEach((show) => {
            if (show.is_sch_disable !== "Y") {
              activeShows.push(show);
            }
          });
        }
      });
      this.Users.forEach((user) => {
        if (activeShows.length === 0) {
          statess[user.user_id] = { checked: false, indeterminate: false };
          return;
        }
        let count = 0;
        activeShows.forEach((show) => {
          if (
            show.selectedUsers &&
            show.selectedUsers.some((u) => u.user_id == user.user_id)
          ) {
            count++;
          }
        });
        statess[user.user_id] = {
          checked: count === activeShows.length,
          indeterminate: count > 0 && count < activeShows.length,
        };
      });
      return statess;
    },
  },

  beforeMount() {
    const { md_id, date } = this.$route.query;
    this.getCinemasList();

    if (md_id) {
      this.selected.MovieId = md_id;
      if (date && moment(date).isValid()) {
        this.selected.FromDate = moment(date).toDate();
        this.selected.ToDate = moment(date).toDate();
      }
      this.getMoviesList(md_id);
    } else {
      this.getMoviesList();
    }
  },
  mounted() {
    this.getviewingnumber();
    this.getPosAggregatorUsers();
  },
  methods: {
    onSelectCinema(obj) {
      this.cinema_id = obj["cine_id"];
      this.selectedScreen = "";
      this.screenList = [];
      this.getScreensList(obj.cine_id);
    },
    onRemoveCinema() {
      this.cinema_id = null;
      this.selectedScreen = "";
      this.screenList = [];
    },
    onSelectScreen() {},
    onRemoveScreen() {
      this.selectedScreen = "";
    },
    getScreensList(cine_id) {
      scheduleService
        .GetScreens({ cinema_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.screenList = data.Records;
          } else {
            console.log("Screens error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCinemasList: function (cine_id) {
      this.cinemaList = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onClickMovieList() {
      this.$refs.searchMoviesList.focus();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getMovieBasedSchedule();
      } else {
        this.currentPage = event;
        this.getMovieBasedSchedule();
      }
    },
    onSearchMovie: function () {
      if (this.searchMovie && this.searchMovie.length > 0) {
        this.MoviesList = this.MoviesListCopy.filter((x) => {
          if (
            x.movie_title.toLowerCase().includes(this.searchMovie.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.MoviesList = this.MoviesListCopy;
      }
    },
    getMovieBasedSchedule: function (submitBtn = false) {
      if (!this.cinema_id) {
        return this.$toasted.show("Please Select Cinema");
      }
      this.Records = [];
      this.pendingChanges = {};
      if (submitBtn) {
        this.currentPage = 1;
      }
      let loader = this.$loading.show();
      let payload = {
        movie_id: this.selected.MovieId,
        fromDate: moment(this.selected.FromDate).isValid()
          ? moment(this.selected.FromDate).format("YYYY-MM-DD")
          : "",
        toDate: moment(this.selected.ToDate).isValid()
          ? moment(this.selected.ToDate).format("YYYY-MM-DD")
          : "",
        cinema_id: this.selectedCinema ? this.selectedCinema.cine_id : "",
        screen_id: this.selectedScreen ? this.selectedScreen.screen_id : "",
        limit: this.perPage,
        currentPage: this.currentPage,
      };
      MasterService.GetMovieBasedSchedule(payload)
        .then((response) => {
          const { data } = response;
          loader.hide();
          if (data && data.Records && data.Records.length > 0 && data.status) {
            // Backend reuses one selectedUsers array across shows — clone per show
            this.Records = data.Records.map((movie) => ({
              ...movie,
              Shows: (movie.Shows || []).map((show) => ({
                ...show,
                selectedUsers: Array.isArray(show.selectedUsers)
                  ? show.selectedUsers.map((u) => ({ ...u }))
                  : [],
              })),
            }));
            this.selectionEpoch = 0;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue =
                this.selectedvalue < 10 ? 10 : this.selectedvalue;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
            this.rows = 0;
            this.selectedvalue = this.perPage;
          }
        })
        .catch((err) => {
          loader.hide();
          this.$toasted.show(err);
        });
    },
    getMoviesList: function (md_id) {
      let payload = {
        limit: null,
        currentPage: null,
      };
      MovieService.GetMovies(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            this.MoviesList = data.MovieListResult;
            this.MoviesListCopy = data.MovieListResult;
            if (md_id) {
              let selectedMovie = data.MovieListResult.find(
                (x) => x.md_id == md_id
              );
              if (selectedMovie) {
                this.selected.Movie = selectedMovie.movie_title;
                this.selected.MovieId = selectedMovie.md_id;
              }
            }
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("error :", error);
        });
    },
    onSelectHandler: function (type, value) {
      if (type == "movie") {
        this.selected.Movie = value.movie_title;
        this.selected.MovieId = value.md_id;
        this.searchMovie = "";
        this.ChangeMovie = true;
        this.onSearchMovie();
      }
    },
    onSelectAll: function (type) {
      if (type == "movie") {
        this.selected.MovieId = null;
        this.selected.Movie = "All";
      }
    },

    getPosAggregatorUsers: function () {
      MasterService.GetPosAggregatorUsers()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Users = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    onRemove: function (show, event) {
      let request_payload = {
        md_id: show.md_id,
        ss_id: show.ss_id,
        aggregator_user_id: event.user_id,
        asm_is_active: true,
        cinema_id:
          this.cinema_id ||
          (this.selectedCinema && this.selectedCinema.cine_id) ||
          null,
      };
      const key = `${show.md_id}_${show.ss_id}_${event.user_id}`;
      this.$set(this.pendingChanges, key, request_payload);
    },
    onSelect: function (show, event) {
      let request_payload = {
        md_id: show.md_id,
        ss_id: show.ss_id,
        aggregator_user_id: event.user_id,
        asm_is_active: false,
        cinema_id:
          this.cinema_id ||
          (this.selectedCinema && this.selectedCinema.cine_id) ||
          null,
      };
      const key = `${show.md_id}_${show.ss_id}_${event.user_id}`;
      this.$set(this.pendingChanges, key, request_payload);
    },
    getHeaderState(userId) {
      return (
        this.headerCheckboxStates[userId] || {
          checked: false,
          indeterminate: false,
        }
      );
    },
    isUserSelected(show, user) {
      // Depend on selectionEpoch so checkbox UI re-renders after toggle
      void this.selectionEpoch;
      return (
        show.selectedUsers &&
        show.selectedUsers.some((u) => u.user_id == user.user_id)
      );
    },
    onToggleUserInShow(show, user) {
      const currentUsers = Array.isArray(show.selectedUsers)
        ? [...show.selectedUsers]
        : [];
      if (this.isUserSelected(show, user)) {
        this.$set(
          show,
          "selectedUsers",
          currentUsers.filter((u) => u.user_id != user.user_id)
        );
        this.onRemove(show, user);
      } else {
        currentUsers.push({ ...user });
        this.$set(show, "selectedUsers", currentUsers);
        this.onSelect(show, user);
      }
      this.selectionEpoch += 1;
    },
    async onBulkToggleUser(user) {
      const state = this.getHeaderState(user.user_id);
      const shouldRemove = state.checked;
      const activeShows = [];
      this.Records.forEach((movie) => {
        if (movie.Shows) {
          movie.Shows.forEach((show) => {
            if (show.is_sch_disable !== "Y") {
              activeShows.push(show);
            }
          });
        }
      });

      let changeCount = 0;
      activeShows.forEach((show) => {
        const isSelected = this.isUserSelected(show, user);
        const currentUsers = Array.isArray(show.selectedUsers)
          ? [...show.selectedUsers]
          : [];
        if (shouldRemove && isSelected) {
          this.$set(
            show,
            "selectedUsers",
            currentUsers.filter((u) => u.user_id != user.user_id)
          );
          this.onRemove(show, user);
          changeCount++;
        } else if (!shouldRemove && !isSelected) {
          currentUsers.push({ ...user });
          this.$set(show, "selectedUsers", currentUsers);
          this.onSelect(show, user);
          changeCount++;
        }
      });
      if (changeCount > 0) {
        this.selectionEpoch += 1;
        this.$toasted.show(
          "Changes staged for " +
            changeCount +
            " schedule(s). Click Save to apply."
        );
      }
    },
    async onSaveChanges() {
      const changes = Object.values(this.pendingChanges);
      if (changes.length === 0) {
        this.$toasted.show("No pending changes to save.");
        return;
      }
      let loader = this.$loading.show();
      try {
        const promises = changes.map((payload) =>
          MasterService.SetAccessScheduleMapping(payload)
        );
        await Promise.all(promises);
        this.$toasted.show(
          "Successfully saved " + changes.length + " schedule updates!"
        );
        this.pendingChanges = {};
        loader.hide();
        this.getMovieBasedSchedule();
      } catch (err) {
        this.$toasted.show("Some updates may have failed");
        loader.hide();
      }
    },
    onHeaderScroll(e) {
      if (this._syncing) return;
      this._syncing = true;
      const scrollLeft = e.target.scrollLeft;
      const els = this.$el.querySelectorAll(".ars-body-scroll");
      els.forEach((el) => {
        el.scrollLeft = scrollLeft;
      });
      requestAnimationFrame(() => {
        this._syncing = false;
      });
    },
    onBodyScroll(e) {
      if (this._syncing) return;
      this._syncing = true;
      const scrollLeft = e.target.scrollLeft;
      if (this.$refs.headerScroll) {
        this.$refs.headerScroll.scrollLeft = scrollLeft;
      }
      const els = this.$el.querySelectorAll(".ars-body-scroll");
      els.forEach((el) => {
        if (el !== e.target) el.scrollLeft = scrollLeft;
      });
      requestAnimationFrame(() => {
        this._syncing = false;
      });
    },
  },
};
</script>

<style>
.disableSchProp {
  background-color: #d3d3d330;
  color: #a3a0a0;
  cursor: not-allowed;
}
.light_grey_back:nth-child(odd) {
  background-color: #f5f5f5;
}
.hei {
  padding: 0.35rem !important;
}

.ars-nowrap-table th,
.ars-nowrap-table td {
  white-space: nowrap !important;
}

.ars-users-header {
  padding: 0 !important;
  vertical-align: bottom;
  min-width: 200px;
}
.ars-users-label {
  text-align: center;
  padding: 8px 8px 6px;
  font-weight: 600;
  font-size: 13px;
  color: #334155;
  border-bottom: 1px solid #e2e8f0;
}
.ars-scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.ars-header-scroll {
  background: #f8f7fc;
  padding: 6px 0;
}
.ars-header-scroll::-webkit-scrollbar {
  height: 5px;
}
.ars-header-scroll::-webkit-scrollbar-track {
  background: #f1f0f5;
  border-radius: 3px;
}
.ars-header-scroll::-webkit-scrollbar-thumb {
  background: #c4b5d9;
  border-radius: 3px;
}
.ars-body-scroll {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.ars-body-scroll::-webkit-scrollbar {
  display: none;
}
.ars-users-row {
  display: flex;
  align-items: center;
  min-width: max-content;
}
.ars-user-col {
  flex: 0 0 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 6px;
}

.ars-checkbox-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 118px;
  gap: 5px;
  cursor: pointer;
  user-select: none;
  padding: 3px 8px;
  border-radius: 0;
  border: 1px solid transparent;
  transition: all 0.15s ease;
  font-size: 11.5px;
  white-space: nowrap;
  margin: 0;
}
.ars-checkbox-wrap:hover {
  background: transparent;
  border-color: #ddd5ee;
}
.ars-checkbox-wrap.ars-checked {
  background: transparent;
  border-color: transparent;
}
.ars-checkbox-wrap input[type="checkbox"] {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #c4b5d9;
  border-radius: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  transition: all 0.15s ease;
  background: #fff;
  margin: 0;
}
.ars-checkbox-wrap input[type="checkbox"]:checked {
  background: #fff;
  border-color: #10b981;
}
.ars-checkbox-wrap input[type="checkbox"]:checked::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #10b981;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.ars-checkbox-wrap input[type="checkbox"]:indeterminate {
  background: #fff;
  border-color: #10b981;
}
.ars-checkbox-wrap input[type="checkbox"]:indeterminate::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 5px;
  width: 6px;
  height: 2px;
  background: #10b981;
  border-radius: 1px;
}
.ars-checkbox-wrap input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ars-checkbox-wrap span {
  color: #475569;
  font-weight: 500;
  letter-spacing: 0.01em;
}
.ars-checkbox-wrap--header span {
  color: #334155;
  font-weight: 600;
}

.ars-users-cell {
  padding: 2px 0 !important;
  vertical-align: middle;
}
.ars-disabled-text {
  text-align: center;
  color: #a3a0a0;
  font-size: 12px;
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/AccessRightsComponents/AccessRightsForSchedule.vue